import { differenceInHours } from "date-fns";
import { useViewerDecks, useViewerQuery } from "queries/viewerQuery";
import React from "react";
import { useNavigate } from "react-router";
import { useMatchMain } from "root/RootRouter";
import { NOCARDSHASH } from "../../components/dialogs/NoCardsDialog";
import { useLocation } from "react-use";
import { SHARE_AND_CHROME_QUEST } from "../../sharedJs__generated/constants";
import { useGetState } from "../../components/ReduxProvider";
import { MAIN } from "../RootRouter.config";

export const useNoCardsDialogIfNoCards = () => {
  const { deck } = useViewerDecks();
  const { isLoading, hintWasSeen } = useViewerQuery();
  const navigate = useNavigate();

  const noCardsDialogShown = useGetState("noCardsDialogShown");
  const inMain = useMatchMain({ end: true });
  const location = useLocation();

  // disable redirect for 1 hour since user saw LearnNoCards last time
  const disabled = noCardsDialogShown && differenceInHours(new Date(), new Date(noCardsDialogShown)) < 1;

  const notEnoughCardsInToLearn = deck && deck.stats.unknown < 3;

  const handleUseEffect = () => {
    if (!hintWasSeen(SHARE_AND_CHROME_QUEST) || (deck && deck.stats.total < 20)) return;

    if (notEnoughCardsInToLearn && inMain && !disabled && !isLoading && location.hash !== NOCARDSHASH) {
      navigate(MAIN.url() + NOCARDSHASH, { replace: true });
    }
  };

  React.useEffect(() => {
    // this gives time to update isLoading if new viewer is requested at the same time as this useeffect is called (there is a race condition when users opens app from background after some time)
    const timeout = setTimeout(handleUseEffect, 100);
    return () => {
      clearTimeout(timeout);
    };
  });
};
